/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import FormikInput from 'src/components/formik/FormikInput';
import FormikSelect from 'src/components/formik/FormikSelect';
import { CC_TYPES_LIST, VEHICLE_ORIGIN_TYPES_LIST, VEHICLE_STATUS_TYPES_LIST } from 'src/containers/product-container/ProductConstants';

function VehicleInsuranceCatalogue() {
    return (
        <div className="form-row">
            <div className="form-group col-md-3">
                <label>Cubic Capacity (CC)</label>
                <FormikSelect
                    items={CC_TYPES_LIST}
                    name="meta.cubicCapacity"
                    className="form-control"
                />
            </div>
            <div className="form-group col-md-3">
                <label>Vehicle Status</label>
                <FormikSelect
                    items={VEHICLE_STATUS_TYPES_LIST}
                    name="meta.vehicleStatus"
                    className="form-control"
                />
            </div>
            <div className="form-group col-md-3">
                <label>Vehicle Origin</label>
                <FormikSelect
                    items={VEHICLE_ORIGIN_TYPES_LIST}
                    name="meta.vehicleOrigin"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>Vehicle Insurance Interest Rate</label>
                <FormikInput
                    name="meta.vehicleInsuranceInterestRate"
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>Third-Party Amount</label>
                <FormikInput
                    name="meta.thirdPartyValue"
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>Owner Amount</label>
                <FormikInput
                    name="meta.ownerValue"
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>Paid Driver Amount</label>
                <FormikInput
                    name="meta.paidDriverValue"
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>Passenger Amount</label>
                <FormikInput
                    name="meta.passengerValue"
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-3">
                <label>CNG Third Party Amount</label>
                <FormikInput
                    name="meta.cngThirdPartyValue"
                    type="text"
                    className="form-control"
                />
            </div>
        </div>
    );
}

export default VehicleInsuranceCatalogue;
